import CreateRequisite from './CreateRequisite';

export default CreateRequisite;
